export default "__VITE_ASSET__CdvxLFqC__"